class GolfSegmentedTabs extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index), options);
      tab.addEventListener('keydown', event => {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(next, true);
      }, options);
    });
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) {
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        panel.inert = !active;
      }
      if (active && focus) tab.focus();
    });
    this.dispatchEvent(new CustomEvent('gk:tabs:change', { bubbles: true, detail: { value: this.tabs[index].dataset.gkTab } }));
    cancelAnimationFrame(this.refresh);
    this.refresh = requestAnimationFrame(() => document.dispatchEvent(new CustomEvent('gk:coverflow:refresh')));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.refresh);
  }
}
if (!customElements.get('gk-segmented-tabs')) customElements.define('gk-segmented-tabs', GolfSegmentedTabs);
